@if(allowAccess) {
	<div>
		<ng-content ></ng-content>
	</div>
} @else {
	<div >
		You don't have access to this page.
	</div>
}